import classNames from 'classnames';
import { Button } from 'devextreme-react/button';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import { useScreenSize } from '../../../utils/media-query';
import { ReactNode, useEffect, useRef, useState } from 'react';

interface PanelDetailsProps {
  children?: ReactNode;
  isVisible: boolean;
  isPinned: boolean;
  onClose: () => void;
  onOpen?: () => void;
  onPin?: (pinned: boolean) => void;
  includePin?: boolean;
  title?: string;
}

export const PanelDetails = ({ children, isVisible, isPinned, onClose, onOpen, onPin, includePin = true, title = 'Elementos' }: PanelDetailsProps) => {
  const contenedorRef = useRef<HTMLDivElement>(null);
  const [localPanelVisible, setLocalPanelVisible] = useState(isVisible);

  const handlePined = () => {
    if (onPin) {
      onPin(!isPinned);
    }
  };

  const { isLarge, isMedium } = useScreenSize();

  useEffect(() => {
    setLocalPanelVisible(isVisible);
  }, [isVisible]);

  useEffect(() => {
    if (isLarge || isMedium) {
      setLocalPanelVisible(isVisible);
      return;
    }
    setLocalPanelVisible(false);
    if (isVisible && onClose) {
      onClose();
    }
  }, [isLarge, isMedium]);

  const handleClickOutside = (event: MouseEvent) => {
    if (localPanelVisible && !isPinned) {
      if (contenedorRef.current && !contenedorRef.current.contains(event.target as Node)) {
        handlePanelClose();
      }
    }
  };

  useEffect(() => {
    if (localPanelVisible && !isPinned) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }
    // Limpia el evento cuando el componente se desmonta
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [localPanelVisible, isPinned]);

  const handlePanelClose = () => {
    if (!isPinned) {
      document.removeEventListener('click', handleClickOutside);
      if (onClose) {
        onClose();
      }
    }
  };

  const handlePanelCloseInSide = () => {
    document.removeEventListener('click', handleClickOutside);
    if (onClose) {
      onClose();
    }
  };

  return (
    <div id='contact-panel' ref={contenedorRef} className={classNames({ panel: true, open: localPanelVisible, pin: isPinned && (isLarge || isMedium), unpin: !isPinned })}>
      <div className='data-wrapper'>
        <Toolbar className='panel-toolbar'>
          <ToolbarItem location='before'>
            <span className='contact-name value'>{title}</span>
          </ToolbarItem>
          {includePin && (
            <ToolbarItem location='after' visible={isLarge || isMedium}>
              <Button icon={isPinned ? 'pin' : 'unpin'} onClick={handlePined} />
            </ToolbarItem>
          )}
          <ToolbarItem location='after'>
            <Button icon='close' onClick={handlePanelCloseInSide} />
          </ToolbarItem>
        </Toolbar>
        <div className='panel-scroll' style={{ height: 'calc(100% - 60px)', overflow: 'auto' }}>
          {children}
        </div>
      </div>
    </div>
  );
};
